import React from "react";



const galleryItems = [
  { id: 1, img: "/images/gallery/1.jpg", filter: "cat-1" },
  { id: 1, img: "/images/gallery/2.jpg", filter: "cat-1" },
  { id: 1, img: "/images/gallery/3.jpg", filter: "cat-1" },
  { id: 1, img: "/images/gallery/4.jpg", filter: "cat-1" },
  { id: 1, img: "/images/gallery/5.jpg", filter: "cat-1" },
  { id: 1, img: "/images/gallery/6.jpg", filter: "cat-1" },
  { id: 1, img: "/images/gallery/7.jpg", filter: "cat-1" },
  { id: 1, img: "/images/gallery/8.jpg", filter: "cat-1" },
  // { id: 1, img: "/images/gallery/9.jpg", filter: "cat-1" },
  { id: 2, img: "/images/gallery/10.jpg", filter: "cat-2" },
  { id: 3, img: "/images/gallery/11.jpg", filter: "cat-3" },
  { id: 4, img: "/images/gallery/12.jpg", filter: "cat-4" },
  { id: 5, img: "/images/gallery/13.jpg", filter: "cat-5" },
  { id: 6, img: "/images/gallery/14.jpg", filter: "cat-2" },
  // { id: 7, img: "/images/gallery/15.jpg", filter: "cat-3" },
  { id: 8, img: "/images/gallery/16.jpg", filter: "cat-1" },
  { id: 8, img: "/images/gallery/17.jpg", filter: "cat-1" },
  // { id: 8, img: "/images/gallery/18.jpg", filter: "cat-1" },
  // { id: 8, img: "/images/gallery/19.jpg", filter: "cat-1" },
  // { id: 8, img: "/images/gallery/20.jpg", filter: "cat-1" },
  // { id: 8, img: "/images/gallery/21.jpg", filter: "cat-1" },
];

const gallerySection = () => {
  return (



    <>
<section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
      <h1>Gallery</h1>
    </div>
  </div>
</section>


  
    
    <section className="gallery-section-four light-bg mx-60 border-shape-top border-shape-bottom">
      <div className="auto-container">
        {/* Filter Tabs */}
       
        {/* gallery Items */}
        <div className="sortable-masonry">
          <div className="items-container row">
            {galleryItems.map((item) => (
              <div
                key={item.id}
                className={`gallery-block-four gallery-overlay masonry-item all ${item.filter} col-lg-4 col-md-6`}
              >
                <div className="inner-box">
                  <div className="image">
                    <img src={item.img} alt={`gallery ${item.id}`} />
                  </div>
                  {/* <div className="overlay-box"> */}
                    {/* <div className="overlay-inner"> */}
                      {/* <div className="content">
                        <a
                          href=""
                          className="lightbox-image link"
                          data-fancybox="gallery"
                        >
                          <span className="icon fas fa-eye"></span>
                        </a>
                      </div> */}
                    {/* </div>
                  </div> */}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default gallerySection;
